var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m16.25 7.804-9.308 9.313a.724.724 0 0 1-.53.223.724.724 0 0 1-.53-.223.724.724 0 0 1-.222-.53c0-.204.074-.38.223-.53l9.313-9.307H7a.725.725 0 0 1-.534-.216A.726.726 0 0 1 6.25 6c0-.213.072-.391.216-.535A.726.726 0 0 1 7 5.25h9.846c.256 0 .47.087.644.26.173.173.26.388.26.644V16c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216.725.725 0 0 1-.535-.216.726.726 0 0 1-.215-.534V7.804Z",
    fill: "currentColor"
  })));
};
export default SvgTransfer;